import { render, staticRenderFns } from "./RegisterUserCard.vue?vue&type=template&id=1306131a&"
import script from "./RegisterUserCard.vue?vue&type=script&lang=js&"
export * from "./RegisterUserCard.vue?vue&type=script&lang=js&"
import style0 from "./RegisterUserCard.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports